import { FilterTypes } from 'Core/interfaces'

import { UrlParams } from 'Portals/Customer/constants'
import { Report, ReportFilterFields, ReportMainSearchFields } from 'Portals/Customer/entities'
import i18n from 'Portals/Customer/utils/i18nService'

export const getMainSearchConfig: () => Report.Search.Config = () => ({
	[ReportMainSearchFields.reportName]: {
		label: i18n.t('pages:reports.filter.reportName'),
		apiFieldName: ReportMainSearchFields.reportName,
		apiSearchFieldName: 'reportName',
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.reportName
	}
})

export const getFilterConfig: () => Report.Filter.Config = () => ({
	[ReportFilterFields.dateFrom]: {
		label: i18n.t('pages:reports.filter.dateFrom'),
		apiFilterFieldName: 'rangeFrom',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.startDate,
		defaultValue: null
	},
	[ReportFilterFields.dateTo]: {
		label: i18n.t('pages:reports.filter.dateTo'),
		apiFilterFieldName: 'rangeTo',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.endDate,
		defaultValue: null
	},
	[ReportFilterFields.status]: {
		label: i18n.t('pages:reports.filter.status'),
		apiFilterFieldName: 'status',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.statusId,
		defaultValue: ''
	}
})
